import styled from 'styled-components'

interface CellContentProps {
  isCopied: boolean
}

export const StyledTableCell = styled.td<{ hasTextWrapping: boolean }>`
  ${({ hasTextWrapping }) =>
    hasTextWrapping &&
    `
    white-space: normal;
    word-wrap: break-word;
  `}

  a {
    text-decoration: underline;
    color: #303032;
  }
`

export const CellContent = styled.span<CellContentProps>`
  background-color: ${({ isCopied }) => (isCopied ? '#d4edda' : 'transparent')};
  padding: '0 2px';
  border-radius: '2px';
  line-height: '1.4';
  transition: background-color 0.3s ease;
  display: block;
`

export const EditableCell = styled.td`
  padding: 0;
`
